import { PropsWithChildren, ReactNode } from 'react';
import { Box } from '@bridebook/ui';
import AppBarMobile from '@bridebook/web/components/app-bar/app-bar-mobile/app-bar-mobile';
import AppBarBackButton from '../partials/app-bar-back-button';
import componentStyles from './app-bar-mobile-basic.style';

interface IProps extends PropsWithChildren {
  title?: string | ReactNode;
  onBack?: () => void;
  hideBorder?: boolean;
  rightElement?: ReactNode;
  showBackButton?: boolean;
}

export const APP_BAR_MOBILE_BASIC_OFFSET = 54;

const AppBarMobileBasic = ({
  title = '',
  onBack,
  children,
  hideBorder,
  rightElement,
  showBackButton = true,
}: IProps) => {
  const styles = componentStyles(hideBorder);

  return (
    <AppBarMobile topStyle={styles.appBarStyles} scrolledStyle={styles.appBarStyles}>
      <Box py={4} px={4}>
        <Box style={styles.innerWrapper}>
          {showBackButton && (
            <Box style={styles.backButton}>
              <AppBarBackButton onClick={onBack} />
            </Box>
          )}
          <Box style={styles.title}>{title}</Box>
          {rightElement && <Box style={styles.rightElement}>{rightElement}</Box>}
        </Box>
      </Box>
      {children}
    </AppBarMobile>
  );
};

export default AppBarMobileBasic;
